import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { Cargo, Funcionario } from '../../../../../models/cadastro.model';
import { ErrorModel } from '../../../../../models/error.model';

@Component({
  selector: 'app-funcionarios-manutencao',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgxMaskDirective],
  templateUrl: './funcionarios-manutencao.component.html',
  styleUrl: './funcionarios-manutencao.component.css'
})
export class FuncionariosManutencaoComponent implements OnInit {
  funcionarioForm: FormGroup;
  isEditMode = false;
  funcionarioId: number | null = null;
  cargos: Cargo[] = [];
  ufs: string[] = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

  private fb = inject(FormBuilder);
  private cadastroService = inject(CadastroService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private toastr = inject(ToastrService);

  constructor() {
    this.funcionarioForm = this.fb.group({
      id: [0],
      cargoId: [null, Validators.required],
      nome: ['', Validators.required],
      sobrenome: ['', Validators.required],
      telefone: ['', Validators.required],
      cpf: ['', Validators.required],
      cep: [''],
      enderecoRua: [''],
      enderecoNumeroPredial: [''],
      enderecoCidade: [''],
      enderecoUf: ['SP'],
      enderecoPais: ['Brasil'],
      enderecoBairro: ['']
    });
  }

  ngOnInit(): void {
    this.loadCargos();

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.funcionarioId = +params['id'];
        this.loadFuncionario(this.funcionarioId);
      }
    });
  }

  loadCargos(): void {
    this.cadastroService.getCargos().subscribe({
      next: (data) => {
        this.cargos = data;
      },
      error: () => {
        this.toastr.error('Erro ao carregar cargos.');
      }
    });
  }

  loadFuncionario(id: number): void {
    this.cadastroService.getFuncionarioById(id).subscribe({
      next: (funcionario) => {
        this.funcionarioForm.patchValue(funcionario);
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar funcionário.');
      }
    });
  }

  salvarFuncionario(): void {
    if (this.funcionarioForm.invalid) {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const formValue = this.funcionarioForm.getRawValue();
    const funcionario: Funcionario = {
      ...formValue,
      cpf: formValue.cpf?.replace(/\D/g, ''),
      telefone: formValue.telefone?.replace(/\D/g, ''),
      cep: formValue.cep?.replace(/\D/g, ''),
      cargoDescricao: '',
      cargoNivel: ''
    };

    if (this.isEditMode && this.funcionarioId !== null) {
      this.cadastroService.updateFuncionario(this.funcionarioId, funcionario).subscribe({
        next: () => {
          this.toastr.success('Funcionário atualizado com sucesso!');
          this.router.navigate(['/home/cadastro-funcionario']);
        },
        error: (error) => {
          const erro: ErrorModel = error.error;
          this.toastr.error(erro?.message || 'Erro ao atualizar funcionário.');
        }
      });
      return;
    }

    this.cadastroService.createFuncionario(funcionario).subscribe({
      next: () => {
        this.toastr.success('Funcionário criado com sucesso!');
        this.router.navigate(['/home/cadastro-funcionario']);
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao criar funcionário.');
      }
    });
  }

  cancelar(): void {
    this.router.navigate(['/home/cadastro-funcionario']);
  }
}